var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiveStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 18,
    viewBox: "0 0 136 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0L11.0206 6.21885H17.5595L12.2694 10.0623L14.2901 16.2812L9 12.4377L3.70993 16.2812L5.73056 10.0623L0.440492 6.21885H6.97937L9 0Z",
    fill: "#F57F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0908 0L42.1114 6.21885H48.6503L43.3603 10.0623L45.3809 16.2812L40.0908 12.4377L34.8008 16.2812L36.8214 10.0623L31.5313 6.21885H38.0702L40.0908 0Z",
    fill: "#F57F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9092 0L69.9298 6.21885H76.4687L71.1786 10.0623L73.1992 16.2812L67.9092 12.4377L62.6191 16.2812L64.6397 10.0623L59.3497 6.21885H65.8886L67.9092 0Z",
    fill: "#F57F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3638 0L99.3844 6.21885H105.923L100.633 10.0623L102.654 16.2812L97.3638 12.4377L92.0737 16.2812L94.0943 10.0623L88.8043 6.21885H95.3431L97.3638 0Z",
    fill: "#F57F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.636 0L129.473 6.21885H135.418L130.609 10.0623L132.446 16.2812L127.636 12.4377L122.827 16.2812L124.664 10.0623L119.855 6.21885H125.799L127.636 0Z",
    fill: "#F57F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveStars);
export default __webpack_public_path__ + "static/media/five_stars.c195f492e562dc185604dbca952bfb06.svg";
export { ForwardRef as ReactComponent };